namespace Gordic.Uda.WebControls {
    let gcontent = Decorators.gcontent;

    /**
     * Zveřejnění el. obrazu / přílohy do poblikačního úložiště
     *
     * @author Jindřich Vácha
     * @since 480.2.0.0
     */
    @gcontent
    export class ZverejneniTabs extends GContentBase {

        /**
         * Obsah tabu (subtasku) zveřejnění
         * @type {JQuery}
         */
        private $zverejneniDiv: JQuery;
        /**
         * Obsah tabu (subtasku) historie
         * @type {JQuery}
         */
        private $historyDiv: JQuery;

        /**
         * Grid s historií
         * @type {JQuery}
         */
        private $gridHistory: JQuery;
        /**
         * Výpis detailu řádku historie (dynamicky při změně řádku – zdrojem pro data je history grid)
         * @type {JQuery}
         */
        private $historyDetailTabObsah: JQuery;

        /**
         * Zda už došlo k loadu zveřejnění tab
         * @type {boolean}
         */
        private isZverejneniTabAlreadyLoaded: boolean;

        /**
         * Zda už došlo k loadu hist. tab
         * @type {boolean}
         */
        private isHistorieTabAlreadyLoaded: boolean;

        /**
         * model (definovane jako ContentValues)
         * @type {Gordic.Uda.WebControls.ZverejneniDto}
         */
        protected model: Gordic.Uda.WebControls.ZverejneniDto;
        /**
         * validators (definovane jako ContentValues)
         * @type {any}
         */
        protected validators: any;


        //-----------------------------------------------------------------------------------------------------
        /**
         * Definice formuláře
         */
        public onContentReady(): void {
            
            let that = this;

            console.log("Gordic.Uda.WebControls.ZverejneniTabs.onContentReady", this);

            this.taskId = this.model.hist_only ? "actZverejneniHistTab" : "actZverejneniTabs";


            this.isZverejneniTabAlreadyLoaded = false;
            this.isHistorieTabAlreadyLoaded = false;

            this.actions.addRange({
                // GSUBTASKS (taby)
                actZverejneniTab: {
                    enabled: true,
                    caption: "jres:24450045", //RC 24450045 : Zveřejnění
                    run: function () {
                        that.LoadZverejneniTab();
                    }
                },
                actHistorieTab: {
                    enabled: true,
                    caption: "jres:24450056", //RC 24450056 : Historie
                    run: function () {
                        that.LoadHistorieTab();
                    }
                },
                // tlačidla
                actZverejnit: {
                    name: "actZverejnit",
                    caption: "jres:24450065", //RC 24450065 : Zveřejnit
                    icon: "fa-save",
                    run: function (ev, ctx) {
                        that.saveDetail();
                    }
                },
                actCancel: {
                    name: "actCancel",
                    caption: "jres:24450058", //RC 24450058 : Zrušit
                    icon: "gi-window-close",
                    run: function (ev, ctx) {
                        that.tryClose();
                    }
                },
            });

            if (!this.model.hist_only) {

                // Okno se zveřejněním –> Subtasky + LoadZverejneni
                $("<div>").appendTo(this.element)
                    .gsubtasks({
                        params: [
                            //caption se vezme rovnou z act...
                            { action: this.actions.actZverejneniTab },
                            { action: this.actions.actHistorieTab },
                        ],
                    });

                this.LoadZverejneniTab();

            } // !hist_only
            else {
                // jen historii
                this.LoadHistorieTab();
                // commandbar (tlačítka na spodu okna)
                this.commandBar([
                    { action: this.actions.actCancel },
                ]);

            }

        } // onContentReady

        //-----------------------------------------------------------------------------------------------------
        /**
         * 'closing()' okna – test, jestli je možné okno zavřít
         * 
         * @returns {JQueryPromise<any>} promise (resolve = je možné zavřít, reject = není možné zavřít), boolean určuje, jestli přeselektovat seznam (true) nebo ne (false)
         */
        public closing(): JQueryPromise<any> {

            console.log("ZverejneniTabs.closing()", this);

            // kontrola na změněné položky
            let def = $.Deferred();
            if (this.defaultForm == undefined || this.defaultForm == null || this.defaultForm.gform == undefined || this.defaultForm.gform == null) {
                console.log("defaultForm neexistuje (je null) => zavřu Tab");

                def.resolve();
                return def.promise();
            }

            let formChanged = this.defaultForm!.gform("hasChanged");

            if (formChanged) {
                console.log("byly změny => dotaz na zavření");

                this.dialogs.confirm(
                    "jres:24450059", //RC 24450059 : Dotaz
                    "jres:24450083") //RC 24450083 : Chcete zavřít okno bez uložení změn?
                    .on("yes", def.resolve)
                    .on("close", def.reject);
            }
            else {
                console.log("nebyly změny => zavřu Tab");

                def.resolve();
            }

            return def.promise();
        } // closing

        //-----------------------------------------------------------------------------------------------------
        /**
         * Tab (subtask) 'Zveřejnění'
         */
        private LoadZverejneniTab(): void {
            let that = this;

            console.log("Gordic.Uda.WebControls.ZverejneniTabs.ZverejneniTab()", this);

            // nejsou práva - ukončim
            if (this.model.lze_zverejnit === 0) {
                let dlg = this.dialogs.warning("jres:24450014"); //RC 24450014 : K dané operaci nemáte dostatečná oprávnění.
                dlg.on("close", function () { that.close(); });
                return;
            }

            // schovám historii
            if (this.$historyDiv) {
                this.$historyDiv.hide();
                console.log("hiding historyDiv...");
            }

            if (this.isZverejneniTabAlreadyLoaded == false) {
                this.isZverejneniTabAlreadyLoaded = true;

                console.log("...loading tab", this);

                this.$zverejneniDiv = $("<div>").appendTo(this.element);

                this.defaultForm = $("<div>")
                    .appendTo(this.$zverejneniDiv)
                    .gform("createFrom", new Gordic.Forms.Form({
                        name: "formZverejneni",
                        layoutDescriptor: "L1M1S1, breaks-200-500"
                        //layoutDescriptor: "L2M2S1"
                    })
                        .addSection()
                        .addRow("jres:24450064") //RC 24450064 : Ixb
                        .addField("gstringbox", { name: "ixb", disabled: true, flag: "required" })
                        // schovám ?, když není vyplněno, tak je prázdné...
                        .addRow("jres:24450052") //RC 24450052 : Ixp
                        .addField("gstringbox", { name: "ixp", disabled: true })
                        .addRow("jres:24450032") //RC 24450032 : Soubor
                        .addField("gstringbox", { name: "soubor", disabled: true })
                        .addRow("jres:24450029") //RC 24450029 : Typ
                        .addField("gstringbox", { name: "typ", disabled: true })
                        .addRow("jres:24450042") //RC 24450042 : Titulek
                        .addField("gstringbox", { name: "nazev", flag: "required" })
                        .addRow("jres:24450017") //RC 24450017 : Popis
                        .addField("gstringbox", { name: "popis", rows: 2 })
                        .addRow("jres:24450018") //RC 24450018 : Místo
                        .addField("gselectbox",
                            Gordic.Prefabs.Select.wflsulz(),
                            {
                                name: "ulozisteField",
                                model: "uloziste = ixs_ulz",
                                flag: "required",
                                serverFilters: {
                                    priz_pub: 10,
                                    priz_ud: 0
                                }
                            }) // gselectbox
                        .addRow("jres:24450019") //RC 24450019 : Složka
                        .addField("gselectbox",
                            Gordic.Prefabs.Select.wfldulz(),
                            {
                                name: "slozkaField",
                                flag: "required",
                                model: "slozka = ktg_dms",
                                serverFilters: {
                                    ixs_ulz: new Gordic.Forms.Dependency("ulozisteField", "ixs_ulz", true)
                                }
                            }) // gselectbox
                    ); // .gform

                // commandbar (tlačítka na spodu okna)
                this.commandBar([
                    { action: this.actions.actZverejnit },
                    { action: this.actions.actCancel },
                ]);

                if (this.model.flash) {
                    this.showFlash({ label: this.model.flash, customClass: 'g-state-info' });
                }

                this.defaultForm.findFields()
                    .gfield("model", "apply", this.model, { initialValues: true })
                    .gfield("model", "validators", this.validators);

            } // isZverejneniTabAlreadyLoaded
            else {
                console.log("...already loaded", this);
            }

            // zobrazím zveřejnění
            if (this.$zverejneniDiv != null) {
                this.$zverejneniDiv.show();
            }
            if (this.actions.actZverejnit) {
                this.actions.actZverejnit.visible(true);
            }
        } // LoadZverejneniTab()

        //-----------------------------------------------------------------------------------------------------
        /**
         * Tab (subtask) historie
         */
        private LoadHistorieTab(): void {
            let that = this;

            console.log("Gordic.Uda.WebControls.VyveseniTabs.HistorieTab()", this);

            // schovám zveřejnění
            if (this.$zverejneniDiv) {
                this.$zverejneniDiv.hide();
                console.log("$zverejneniDiv.hide()");
            }
            if (this.actions.actZverejnit) {
                this.actions.actZverejnit.visible(false);
                console.log("actZverejnit.visible(false)");
            }

            // vybuduju zveřejnění
            if (this.isHistorieTabAlreadyLoaded == false) { // první otevření Subtasku
                this.isHistorieTabAlreadyLoaded = true;

                console.log("...loading", this);

                this.$historyDiv = $("<div>").appendTo(this.element);

                this.$gridHistory = $("<div>")//;  //vytvoreni elementu pro $gridHistory
                    //.height(250)        //nastaveni vysky $gridHistory
                    .gautofit()
                    .appendTo(this.$historyDiv)
                    .ggrid<ZverejneniHistDto>({
                        //columnMode: "full", // srazí width sloupců na def. hodnoty
                        marking: false,
                        rowNumbers: false,
                        selection: function (ev, obj) {
                            that.showHistoryDetail();
                        },
                        searchColumns: ["nazev_ulz", "nazev_sloz", "nazev_rf", "soubor", "titule", "popis"],
                        columns: new Gordic.Data.GridFormat()
                            .addTextColumn({
                                name: "ixb"
                                , caption: "Ixb"
                                , width: 130
                                , fixedWidth: true
                                //, visible: false
                            })
                            .addDateTimeColumn({
                                name: "dat_zmena"
                                , caption: "jres:24450069" //RC 24450069 : Datum zveřejnění
                                , width: 130
                                , fixedWidth: true
                            })
                            .addTextColumn({
                                name: "nazev_ulz"
                                , caption: "jres:24450041" //RC  : Úložiště
                                , width: 130
                            })
                            .addTextColumn({
                                name: "nazev_sloz"
                                , caption: "jres:24450019" //RC 24450019 : Složka
                                , width: 130
                            })
                            .addTextColumn({
                                name: "soubor"
                                , caption: "jres:24450032" //RC 24450032 : Soubor
                                , width: 130
                            })
                            .addTextColumn({
                                name: "titulek"
                                , caption: "jres:24450042" //RC 24450042 : Titulek
                                , width: 130
                            })
                            .addTextColumn({
                                name: "popis"
                                , caption: "jres:24450017" //RC 24450017 : Popis
                                , width: 130
                            })
                            .addTextColumn({
                                name: "nazev_rf"
                                , caption: "jres:24450070" //RC 24450070 : Zveřejnil
                                , width: 130
                            })
                    });

                this.$historyDetailTabObsah = $("<div>")
                    .appendTo(this.$historyDiv);


                let view = new Gordic.Data.View(this.model.historie!, { key: "ixs_ulo,por_cislo" });  //key je dulezity kvuli pripadnemu vyhledavani radku
                this.$gridHistory.ggrid("setData", view);

            } // první otevření Subtasku
            else {
                console.log("...already loaded", this);
            }

            // zobrazím historii
            if (this.$historyDiv != null) {
                this.$historyDiv.show();
            }

        } // LoadHistorieTab()


        //-----------------------------------------------------------------------------------------------------
        /**
         * Stisk tlačítka [Zveřejnit]
         */
        private saveDetail(): void {
            let that = this;

            //////////////////////////////////////
            // provedu všechny kontroly
            //////////////////////////////////////
            console.log("Gordic.Uda.WebControls.ZverejneniTabs.saveDetail()", this);

            //Vyvolani validace (pouze v JS bez volani serveru)
            if (!this.defaultForm!.gform("isValid")) {
                return;
            }

            let ff = this.defaultForm!.findFields(/*"text2, text3"*/)            //NOTE: Lze zadavat name jednotlivych fieldu
                .gfield("model", "collect", this.model);

            console.log("saveDetail() – after collect", this.model);

            //////////////////////////////////////
            // Už bylo něco vyvěšeno, na to se přeptám
            //////////////////////////////////////
            if (this.model.historie && this.model.historie.length > 0) {
                this.dialogs.confirm(
                    "jres:24450059", //RC 24450059 : Dotaz
                    "jres:24450060" //RC 24450060 : Zveřejnění již bylo provedeno, viz záložka Historie.
                    + "<br/>"
                    + "jres:24450061") //RC 24450061 : Přejete si zveřejnění zopakovat?
                    .on("yes", function () { that.saveDetailReal(); });
            } else {
                this.saveDetailReal();
            }
        } // saveDetail()

        //-----------------------------------------------------------------------------------------------------
        /**
         * Uložení (vlastní)
         */
        private saveDetailReal(): void {
            let that = this;

            console.log("Gordic.Uda.WebControls.ZverejneniTabs.saveDetailReal()", this);

            this.call<void>("SaveDetail", { model: this.model } /*, null, { applyValidationResultTo: ff } */)
                .done(function (r) {
                    console.log("ZverejneniTabs.saveDetailReal().done()");
                    //console.log("Gordic.Uda.WebControls.Zverejneni.saveDetail.done that", that.model);
                    that.actions.actZverejnit!.enabled(false);
                    that.dialogs.alert("jres:24450066") //RC 24450066 : Zveřejnění bylo úspěšné.
                        .on("close", function () { that.close(); });
                })
                .fail(function (xhr, type, vobj) {
                    console.log("ZverejneniTabs.saveDetailReal().fail()");
                    if (type === "validation") {
                        let msg = "jres:24450028" + ":<br/>"; //RC 24450028 : Chyba validace (server)
                        $.each(vobj, function (k, v) {
                            for (let i = 0; i < v.length; i++)
                                msg += k + ": " + v[i].message + "<br/>";
                        });
                        that.dialogs.error(msg);
                    }
                });
        } // SaveDetailReal()

        //-----------------------------------------------------------------------------------------------------
        /**
         * Zobrazení detailu k řádku historie (data se berou z gridu – i data gridu souborů)
         */
        private showHistoryDetail(): void {

            let that = this;

            let sel: Gordic.Uda.WebControls.ZverejneniHistDto[];
            sel = this.$gridHistory.ggrid("getSelection");
            if (sel.length == 1) {

                let row = sel[0];

                // vyčištění
                this.$historyDetailTabObsah.empty();

                $("<div>")
                    .appendTo(this.$historyDetailTabObsah)
                    .gform("createFrom", new Gordic.Forms.Form({ name: "formNahledHistorieZverejneni", layoutDescriptor: "L1M1S1, breaks-200-500" })
                        .addSection("jres:24450062") //RC 24450062 : Detail historie
                        .addRow("Ixb").addField("gstaticfield", { name: "ixb" })
                        .addRow("jres:24450069") //RC 24450069 : Datum zveřejnění
                        .addField("gstaticfield", { name: "dat_zmena", itemTemplate: "{#:datetime}" } )
                        .addRow("jres:24450041") //RC 24450041 : Úložiště
                        .addField("gstaticfield", { name: "nazev_ulz" })
                        .addRow("jres:24450019") //RC 24450019 : Složka
                        .addField("gstaticfield", { name: "nazev_sloz" })
                        .addRow("jres:24450032") //RC 24450032 : Soubor
                        .addField("gstaticfield", { name: "soubor" })
                        .addRow("jres:24450042") //RC 24450042 : Titulek
                        .addField("gstaticfield", { name: "titulek" })
                        .addRow("jres:24450017") //RC 24450017 : Popis
                        .addField("gstaticfield", { name: "popis" })
                        .addRow("jres:24450070") //RC 24450070 : Zveřejnil
                        .addField("gstaticfield", { name: "nazev_rf" })
                    );

                // naplnění
                this.$historyDetailTabObsah.findFields().gfield("model", "apply", row);
            } // if sel.length == 1

        } // showHistoryDetail()

    } // cls
} // ns
